import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_allocation_configurations_grid_ComponentContextService } from './FootprintManager.allocation_configurations_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_allocation_configurations_gridComponentEntity {
  Id?: number, Content?: string, Context?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Priority?: number, Filters?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, Value?: string }[]}

interface IFootprintManager_allocation_configurations_gridComponentInParams {
  applicable_config_ids?: number[]}


class FootprintManager_allocation_configurations_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_allocation_configurations_gridComponent;
  entity: IFootprintManager_allocation_configurations_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    id: null,
    priority: null,
    context: null,
    entities: null,
    content: null,
    created_on: null,
    created_by: null,
    modified_on: null,
    modified_by: null,
  }



  constructor(
    grid: FootprintManager_allocation_configurations_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_allocation_configurations_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.priority = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.priority,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.context = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.context,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.entities = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.entities,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.content = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.content,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_on = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_on,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_by = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_by,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.modified_on = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.modified_on,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.modified_by = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.modified_by,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_allocation_configurations_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_allocation_configurations_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      applicable_config_ids:  $grid.inParams.applicable_config_ids ,
    };
    const data = await this.$datasources.FootprintManager.allocation_configurations_grid___ds_allocation_configurations_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_allocation_configurations_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.priority.displayControl as TextModel).text = $row.entity.Priority?.toString();
    (this.cells.context.displayControl as TextModel).text = $row.entity.Context;
    (this.cells.entities.displayControl as TextModel).text = $row.entity.Filters?.map(f => `${f.Name} ${f.Value}`)?.join(', ');
    (this.cells.content.displayControl as TextModel).text = $row.entity.Content;
    (this.cells.created_on.displayControl as TextModel).text = $row.entity.CreatedSysDateTime?.toString();
    (this.cells.created_by.displayControl as TextModel).text = $row.entity.CreatedSysUser;
    (this.cells.modified_on.displayControl as TextModel).text = $row.entity.ModifiedSysDateTime?.toString();
    (this.cells.modified_by.displayControl as TextModel).text = $row.entity.ModifiedSysUser;

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'content' : {
        this.on_content_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_content_clicked(event = null) {
    return this.on_content_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_content_clickedInternal(
    $row: FootprintManager_allocation_configurations_gridComponentRowModel,
  $grid: FootprintManager_allocation_configurations_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_allocation_configurations_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'allocation_configurations_grid.on_content_clicked');
  await $shell.Allocations.openconfig_content_codeDialog({ payload: $row.entity.Content, config_id: $row.entity.Id }, 'modal', EModalSize.Large);
  
  $row.refresh();
  $grid.events.on_data_change.emit();
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-allocation_configurations_grid',
  templateUrl: './FootprintManager.allocation_configurations_grid.component.html'
})
export class FootprintManager_allocation_configurations_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_allocation_configurations_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_allocation_configurations_gridComponentInParams = { applicable_config_ids: [] };


  //#region Variables
  //#endregion
  //#region Events
  @Output()
  on_data_change = new EventEmitter<void>();
  
  events = {
    on_data_change: this.on_data_change,
  }
  //#endregion

  headers = {
     id: new GridHeaderModel(new HeaderStyles(null, null), 'id', 'ID', false, false, null, false),       priority: new GridHeaderModel(new HeaderStyles(null, null), 'priority', 'Priority', false, false, null, false),       context: new GridHeaderModel(new HeaderStyles(null, null), 'context', 'Context', false, false, null, false),       entities: new GridHeaderModel(new HeaderStyles(null, null), 'entities', 'Entities', false, false, null, false),       content: new GridHeaderModel(new HeaderStyles(null, null), 'content', 'Content', false, false, null, false),       created_on: new GridHeaderModel(new HeaderStyles(null, null), 'created_on', 'Created on', false, false, null, false),       created_by: new GridHeaderModel(new HeaderStyles(null, null), 'created_by', 'Created by', false, false, null, false),       modified_on: new GridHeaderModel(new HeaderStyles(null, null), 'modified_on', 'Modified on', false, false, null, false),       modified_by: new GridHeaderModel(new HeaderStyles(null, null), 'modified_by', 'Modified by', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_allocation_configurations_gridComponentRowModel[] = [];

  @Input('applicable_config_ids') set $inParams_applicable_config_ids(value: any) {
    this.inParams['applicable_config_ids'] = value;
  }
  get $inParams_applicable_config_ids(): any {
    return this.inParams['applicable_config_ids'] ;
  }

  topToolbar = {
      delete_configs: new ToolModel(new ButtonModel('delete_configs', new ButtonStyles(['destructive'], null), true, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      field_selector: new ToolModel(new SplitButtonModel<{ field_id: ButtonModel, field_priority: ButtonModel, field_context: ButtonModel, field_entities: ButtonModel, field_content: ButtonModel, field_created_on: ButtonModel, field_created_by: ButtonModel, field_modified_on: ButtonModel, field_modified_by: ButtonModel }>(
        'field_selector',
        new ButtonStyles(null, null),
        false,
        false,
        ' ',
        'icon-ic_fluent_task_list_ltr_20_regular',
        null,
        [
          new ButtonModel('field_id', new ButtonStyles(['creation'], null), false, false, false, 'ID', 'icon-ic_fluent_checkmark_circle_20_regular'),
          new ButtonModel('field_priority', new ButtonStyles(['creation'], null), false, false, false, 'Priority', 'icon-ic_fluent_checkmark_circle_20_regular'),
          new ButtonModel('field_context', new ButtonStyles(['creation'], null), false, false, false, 'Context', 'icon-ic_fluent_checkmark_circle_20_regular'),
          new ButtonModel('field_entities', new ButtonStyles(['creation'], null), false, false, false, 'Entities', 'icon-ic_fluent_checkmark_circle_20_regular'),
          new ButtonModel('field_content', new ButtonStyles(['creation'], null), false, false, false, 'Content', 'icon-ic_fluent_checkmark_circle_20_regular'),
          new ButtonModel('field_created_on', new ButtonStyles(null, null), false, false, false, 'Created on', 'icon-ic_fluent_circle_20_regular'),
          new ButtonModel('field_created_by', new ButtonStyles(null, null), false, false, false, 'Created by', 'icon-ic_fluent_circle_20_regular'),
          new ButtonModel('field_modified_on', new ButtonStyles(null, null), false, false, false, 'Modified on', 'icon-ic_fluent_circle_20_regular'),
          new ButtonModel('field_modified_by', new ButtonStyles(null, null), false, false, false, 'Modified by', 'icon-ic_fluent_circle_20_regular')
        ])
    , false)
  };

  bottomToolbar = {
  };



  datasources = {
    ds_allocation_configurations_grid: this.$datasources.FootprintManager.allocation_configurations_grid___ds_allocation_configurations_grid
  }

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_allocation_configurations_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Allocation configurations';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 100;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      applicable_config_ids:  $grid.inParams.applicable_config_ids ,
    };
    try {
      const data = await this.$datasources.FootprintManager.allocation_configurations_grid___ds_allocation_configurations_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_allocation_configurations_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_allocation_configurations_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_allocation_configurations_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_change_field_select(event = null) {
    return this.on_change_field_selectInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_change_field_selectInternal(
    $grid: FootprintManager_allocation_configurations_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_allocation_configurations_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'allocation_configurations_grid.on_change_field_select');
  let field_name = $event?.target?.innerText;
  let enabled = false;
  
  for (let key in $grid.headers) {
      if (field_name === $grid.headers[key].name) {
          if ($grid.headers[key].hidden) {
              $grid.headers[key].hidden = false;
              enabled = true;
          }  else {
              $grid.headers[key].hidden = true;
              enabled = false;
          }
      }
  }
  
  for (let key in $grid.topToolbar.field_selector.control.buttons) {
      if ($grid.topToolbar.field_selector.control.buttons[key].label === field_name) {
          if (enabled) {
              $grid.topToolbar.field_selector.control.buttons[key].icon = 'icon icon-ic_fluent_checkmark_circle_20_regular';
              $grid.topToolbar.field_selector.control.buttons[key].styles.setCreationClass();
          } else {
              $grid.topToolbar.field_selector.control.buttons[key].styles.clearClasses();
              $grid.topToolbar.field_selector.control.buttons[key].icon = 'icon icon-ic_fluent_circle_20_regular';
          }
      }
  }
  
  $event.preventDefault();
  $event.stopPropagation();
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_allocation_configurations_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_allocation_configurations_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'allocation_configurations_grid.on_init');
  if ((await $operations.FootprintManager.Disable_Navigation_Settings_Allocation_Configuration.isAssigned())) { $grid.close(); }
  
  $grid.headers.created_by.hidden = true;
  $grid.headers.created_on.hidden = true;
  $grid.headers.modified_on.hidden = true;
  $grid.headers.modified_by.hidden = true;
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_allocation_configurations_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_allocation_configurations_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'allocation_configurations_grid.on_row_selected');
  
  $grid.topToolbar.delete_configs.control.readOnly = !$grid.hasSelectedRows();
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: FootprintManager_allocation_configurations_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_allocation_configurations_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'allocation_configurations_grid.on_delete_clicked');
  const promises: Promise<{
      reasons?: string[];
      config_id?: number;
  }>[] = [];
  
  for (let row of $grid.selectedRows) {
      promises.push($flows.Allocations.delete_allocation_configuration_flow({ config_id: row.entity.Id }));
  }
  
  const results = await Promise.allSettled(promises);
  
  let successfulRequests: number[] = [];
  let failedRequests: { configId: number; errors: string[]; }[] = [];
  
  for (let i = 0; i < results.length; i++) {
      const result = results[i];
      const configId = $grid.selectedRows[i].entity.Id;
  
      if (result.status === 'fulfilled') {
          if ($utils.isDefined(result.value.reasons)) {
              failedRequests.push({ configId: configId, errors: result.value.reasons });
          } else {
              successfulRequests.push(configId);
          }
      } else if (result.status === 'rejected') {
          failedRequests.push({ configId: configId, errors: [result.reason?.message || 'Unknown error'] });
      }
  }
  
  if (successfulRequests.length > 0 && failedRequests.length > 0) {
      // Mixed
      $shell.Allocations.openToaster('Some configs deleted', `Successfully deleted ${successfulRequests.join(', ')}. Failed to delete ${failedRequests.map(r => `${r.configId}: ${r.errors.join(', ')}`).join(' and ')}`, EToasterType.Warning, { closeButton: true, disableTimeOut: true, positionClass: EToasterPosition.bottomRight });
  } else if (successfulRequests.length > 0) {
      // Success
      $shell.Allocations.openToaster('Some configs deleted', `Successfully deleted ${successfulRequests.join(', ')}.`, EToasterType.Success, { closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight });
  } else {
      // Failed
      $shell.Allocations.openToaster('Some configs deleted', `Failed to delete ${failedRequests.map(r => `${r.configId}: ${r.errors.join(', ')}`).join(' and ')}`, EToasterType.Error, { closeButton: true, disableTimeOut: true, positionClass: EToasterPosition.bottomRight });
  }
  
  $grid.refresh();
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
